import React from "react";
import TablaBitacora from "./TablaBitacora";
import { empleadosApi } from "src/services/empleadosApi";

export default function Bitacora(props) {
  const { valueLaboral, empleado, vista } = props;

  const { data: bitacoras, isLoading: obteniendoBitacoras } =
    empleadosApi.useGetBitacorasEmpleadoQuery(empleado.rut);

  return (
    <>
      {valueLaboral === 2 && (
        <>
          <TablaBitacora
            bitacoras={bitacoras}
            isLoadingBitacoras={obteniendoBitacoras}
            empleado={empleado}
            vista={vista}
          />
        </>
      )}
    </>
  );
}
